/**
 * Feature Announcements Configuration
 *
 * Add new announcements here to spotlight features for users.
 * Each announcement shows once per person (seen state is stored on the server), and a
 * person gets at most one spotlight per day.
 *
 * Keep this list short. Remove an announcement once it is old news: a new hire should
 * not be told a months-old feature is "New".
 *
 * See /docs/feature-spotlight-system.md for full documentation.
 */

export const ANNOUNCEMENTS = [
  // The banner at the top of the dashboard. Its number changed meaning (unread
  // messages -> texts nobody has answered), so staff who know the old widget need
  // the tip. Shows only while someone is waiting: with no banner there is no target.
  {
    id: 'waiting_replies_v1',
    featureId: 'waiting-replies-banner',
    title: 'Patients who texted you are at the top',
    description: 'This counts patients whose last text nobody has answered. Click it to open them.',
    priority: 1,
    position: 'bottom',
  },
];

/**
 * Announcement Schema:
 *
 * @property {string} id - Unique identifier with version suffix (e.g., 'feature_v1')
 *                         Increment version to re-show to users who dismissed previous version
 * @property {string} featureId - Matches data-spotlight="featureId" on target element
 * @property {string} title - Short headline for the tooltip
 * @property {string} description - Explanation of the feature (1-2 sentences)
 * @property {number} priority - Lower numbers show first (1 = highest priority)
 * @property {string} position - Tooltip position: 'top' | 'bottom' | 'left' | 'right'
 * @property {function} [condition] - Optional function returning boolean to conditionally show
 */
